import '../css/blocks.css';

/* standard blocks */

import ctaServices
	from "../../blocks/cta-services/cta-services";

import featuredInsights
	from "../../blocks/featured-insights/featured-insights";

import featuredPosts
	from "../../blocks/featured-posts/featured-posts";

import flexibleContent
	from "../../blocks/flexible-content/flexible-content";

import heroHomeSearch
	from "../../blocks/hero-home/hero-home";

import heroValuesSlider
	from "../../blocks/hero-values-slider/hero-values-slider";

import historyNumbers
	from "../../blocks/history-numbers/history-numbers";

import officeTabs
	from "../../blocks/offices/offices";

import relatedPosts
	from "../../blocks/related-posts/related-posts";

import servicesList
	from "../../blocks/services-list/services-list";

import testimonialsGraduates
	from "../../blocks/testimonials-graduates/testimonials-graduates";

import testimonialsTeam
	from "../../blocks/testimonials-team/testimonials-team";

import text2Cards
	from "../../blocks/text-2-cards/text-2-cards";

import text3Cards
	from "../../blocks/text-3-cards/text-3-cards";

import textCardsSlider
	from "../../blocks/text-cards-slider/text-cards-slider";

import textTilesSlider
	from "../../blocks/text-tiles-slider/text-tiles-slider";

import titleFormColumns
	from "../../blocks/title-form-2-columns/title-form-2-columns";

/* post blocks */

import postEvents
	from "../../blocks/post-events/post-events";

import postOurPeople
	from "../../blocks/post-our-people/post-our-people";

import postResources
	from "../../blocks/post-resources/post-resources";

import postSectors
	from "../../blocks/post-sectors/post-sectors";

import postServices
	from "../../blocks/post-services/post-services";



/*
	Run immediately if the document is already parsed - the block editor's
	iframed canvas (ACF Blocks v3 / WP 7.1+) injects this script into an
	already-loaded document, so 'DOMContentLoaded' has already fired there
	and would never trigger the listener below.
*/
function onReady (fn) {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', fn);
	} else {
		fn();
	}
}

onReady(function () {

	ctaServices ();
	featuredInsights ();
	featuredPosts ();
	flexibleContent ();
	heroHomeSearch ();
	heroValuesSlider ();
	historyNumbers ();
	officeTabs ();
	relatedPosts ();
	servicesList ();
	testimonialsGraduates ();
	testimonialsTeam ();
	text2Cards ();
	text3Cards ();
	textCardsSlider ();
	textTilesSlider ();
	titleFormColumns ();

	postEvents ();
	postOurPeople ();
	postResources ();
	postSectors ();
	postServices ();

});

/*
	Several blocks (offices, testimonials-team, services-list, career-fairs)
	use Flowbite's own data-attribute components (data-tabs-toggle etc.) for
	tab/accordion switching, relying on Flowbite's library-load-time DOMContent
	Loaded scan to wire them up. That scan only ever runs once - it never sees
	markup ACF injects afterwards, whether on the block editor's first preview
	render or any later re-render (eg. on selection), so tabs/accordions in
	those blocks would otherwise render but not respond to clicks in the
	editor. Flowbite exposes initFlowbite() precisely to re-scan for exactly
	this kind of dynamically-added content - call it on every ACF block
	preview (re-)render. This is intentionally generic (not scoped to one
	block type) so any block using Flowbite components, current or future,
	is covered without its own JS file needing to know about this.
*/
const acfInstanceForFlowbite = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstanceForFlowbite) {
	acfInstanceForFlowbite.addAction('render_block_preview', function () {
		if (window.initFlowbite) window.initFlowbite();
	});
}
